import type { ReactElement } from 'react'

import { signInAuthorizationCodeWithToken, updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'
import { redirectToUrl } from '../utils/location'
import { BaseSignInRoute } from './BaseSignInRoute'

export const SignInIOSRoute = (): ReactElement => {
  const platform = 'ios'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  return BaseSignInRoute(async (accessToken, authenticationCode, secondaryFactor, redirectTo) => {
    const url = await signInAuthorizationCodeWithToken(
      accessToken,
      redirectTo ?? '',
      authenticationCode,
      secondaryFactor,
    )
    redirectToUrl(new URL(url.redirect_to, window.location.origin))
  }, platform)
}
